import React from 'react';
import './agreement.scss';
import { useNavigate } from 'react-router-dom';

const Agreement = () => {
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const navigate = useNavigate();

  return (
  <div className='page agreement'>
    <div className='title'>RICECAKE CREATIVE COHORT PARTICIPATION AGREEMENT</div>
    <div className='dates'>Fall 2025 | Cohort Dates: September – November 2025 </div>
    <div className='section'>
      <div className='subtitle'>WHAT THIS IS</div>
      <div className='content'>
      Welcome to the Ricecake Creative Cohort! This agreement outlines shared values, expectations, and commitments to help us build a strong, supportive experience together. It’s not a legal contract—it’s a shared understanding of how we’ll show up for ourselves and each other. We look forward to learning, growing, and working together!
      </div>
      <hr/>
      <div className='subtitle'>RICECAKE VALUES</div>
      <div className='content'>
        <ul>
          <li><span className='bold pink'>Collaboration</span> – together we each hold a collaborative mindset rooted in communication, honesty, and grace for one another
          </li>
          <li><span className='bold pink'>Intentionality</span> – showing up with care, curiosity, and purpose in what we create and how we support each other</li>
          <li><span className='bold pink'>Rest</span> – rest is doing something. We prioritize practices that honor our time, energy, and capacity</li>
          <li><span className='bold pink'>Accessibility</span> – reducing barriers for ourselves and others, and embrace different ways of creating and participating</li>
        </ul>
        We center <span className='bold'>BIPOC, queer, and underrepresented creators</span>, and commit to holding space for one another with care, inclusion, and respect.
      </div>
      <hr/>
      <div className='subtitle'>WHAT PARTICIPATION LOOKS LIKE</div>
      <div className='content'>
        <div className='bold'>Cohort members are committed to:</div>
        <ol>
          <li>
            <div className='bold'>Attend cohort gatherings (3 total) and participate at the SJMade Winter Wonder Market</div>
            These are scheduled creative touchpoints (2 virtual and 1 in-person) to check in, collaborate, and learn. We have scheduled the following dates:
            <ul className='date-list'>
              <li>9/28, 12-1:30pm (<span className='bold'>in-person</span>)

              </li>
              <li>10/21, 8-9pm (virtual check-in & chat) </li>
              <li>11/18, 8-9pm (virtual check-in & chat) </li>
              <li>December - Parallax Winter Market (optional)
              <div className='italic lighter indented'>
                We'll have a Ricecake booth at Parallax (local tattoo shop in Milpitas) for their first Winter Market. It'll be a chance to test your setup and try things out before SJMade!
              </div>
              </li>
              <li>12/13-12/14 - <span className='bold'>SJMADE Winter Wonder Market!</span> <span className='italic lighter'>yay~</span></li>
            </ul>
          </li>
          <div className='bubble indented'>
            <div className='bold'>🌟 Note:</div>
            Cohort members will be featured artists/makers at the Ricecake Collective booth at <span className='bold'>SJMade Winter Wonder Market!</span> ❄️ As part of the cohort, you’ll receive extra support, visibility, and collaborative planning time.
            <br/>
            ✨ Normally, Ricecake takes a <span className='bold'>30% commission</span> on booth sales to help cover shared costs (like booth fees, signage, and staffing). 
            <span className='bold'> Cohort members only pay 15%</span> as a thank-you for being part of this community-centered pilot!
          </div>
          <li>
            <div className='bold'>Contribute to community building</div>
            Whether through feedback, co-working, resource sharing, or cheering someone on—we hope to cultivate a community of support! We will also be working on a collaborative project for the holiday market
          </li>
          <li>
            <div className='bold'>Pursue your creative journey</div>
            This could be building a product line, exploring your art, or learning something new. Creativity comes in many shapes and styles.
          </li>
          <li>
            <div className='bold'>Honor boundaries and capacity</div>
            Rest is part of the work. You are encouraged to engage in ways that feel sustainable and not performative. 
          </li>
          <li>
            <div className='bold'>Communicate openly</div>
            If you need to step back, shift your involvement, or check in about something—please don’t hesitate to reach out. We want to work together with transparency and care.
          </li>
        </ol>
      </div>
      <hr/>
      <div className='subtitle'>✨ What You Can Expect From Us ✨</div>
      As the facilitators, <span className='pink'>Ricecake Collective</span> and <span className='orange'>Summertime Emmy</span> commit to:
      <ul>
        <li>Hosting the 3 cohort meetings and providing space for reflection + connection</li>
        <li>Offering guidance, encouragement, and behind-the-scenes support</li>
        <li>Coordinating art market logistics and bringing the base set-up</li>
        <li>Sharing resources and infrastructure (market tips, signage templates, etc.)</li>
        <li>Advocating for sustainable creative practice—rest counts as progress</li>
        <li>Listening deeply and holding space for feedback</li>
      </ul>
      <div className='spacer-xl'></div>
      <div className='center'>By participating, you’re saying:</div>
      <div className='center italic'>“I’m here to grow—with intention, with care, and with community.”</div>
      <div className='spacer-xl'></div>
      <div className='center bold'>Let’s make some creative magic. 🌈✨</div>

      <div className='apply'><button className='applyButton' onClick={() => navigate('/apply')}>APPLY</button></div>
    </div>
  </div>
  );
}

export default Agreement;
